class TradeCartInFooter extends HTMLElement {
  constructor() {
    super();
    this.footer = this.querySelector('.cart_footer').cloneNode(true);
  }
  renderFooter(tradeinItems, shippingEstimate) {
    const footer = this.querySelector('.cart_footer')
    footer.innerHTML = this.footer.innerHTML //cleans up footer

    const potentialCreditEl = footer.querySelector('.cart__footer-total-credit .cart__footer-value');
    const estimatedShippingEl = footer.querySelector('.cart__footer-shipping-estimate .cart__footer-value');
    const estimateGiftcardEl = footer.querySelector('.cart__footer-giftcard-estimate .cart__footer-value');

    const {
      potentialCreditLow,
      potentialCreditHigh,
      potentialCreditHighDisplay,
    } = calculatePotentialCredit(tradeinItems);
    const { giftcardEstimateLow, giftcardEstimateHigh } = calculateGiftcardEstimate({
      potentialCreditLow,
      potentialCreditHigh,
      shippingEstimate,
    })
    setPrice(potentialCreditEl, [potentialCreditLow, potentialCreditHigh]);
    if (estimatedShippingEl) this.setShippingPrice(estimatedShippingEl, shippingEstimate, potentialCreditHigh);
    if (estimateGiftcardEl) setPrice(estimateGiftcardEl, [giftcardEstimateLow, giftcardEstimateHigh]);

    if (potentialCreditHigh !== potentialCreditHighDisplay) {
      const promotionBonusEl = footer.querySelector('.cart__footer-promotion-bonus');
      const modalOpenerTermsAndConditions = document.getElementById('modal-opener-terms-and-conditions');
      modalOpenerTermsAndConditions.classList.remove('hidden');
      const promotionBonusValueEl = promotionBonusEl.querySelector('.cart__footer-value');
      const promotionBonusValue = potentialCreditHigh - potentialCreditHighDisplay;
      setSinglePrice(promotionBonusValueEl, promotionBonusValue)
      setPrice(potentialCreditEl, [potentialCreditLow - promotionBonusValue, potentialCreditHigh - promotionBonusValue]);

      promotionBonusEl.classList.remove('hidden');
    }
  }

  setShippingPrice(element, estimate, potentialCredit) {
    if (potentialCredit <= 0) {
      element.textContent = '-';
    } else {
      setShippingPrice(element, estimate);
    }
  }
}
customElements.define('trade-in-cart-footer', TradeCartInFooter);
